import { ApiResponse, Service } from '@roc/feature-app-core';

export class InsuranceAgentDirectoryService extends Service {
  getInsuranceAgentsDirectory(): Promise<ApiResponse> {
    return this.get('/api/v1/insurance/getInsuranceAgentsDirectory');
  }
}
